function getTotalOffset() {
  let totalOffset = Number(window?.MinimogSettings?.headerHeight || 0);

  if (window?.MinimogSettings?.stickyAnnouncement || window?.MinimogSettings?.stickyAnnouncement != null) {
    totalOffset += Number(window?.MinimogSettings?.topbarHeight || 0) * 2;
  }

  return totalOffset;
}

document.addEventListener('click', function (event) {
  const inlineAnchor = event.target.closest('[data-v2-inline-anchor]');
  if (inlineAnchor) {
    const targetSelector = inlineAnchor.getAttribute('data-target-section');
    const targetSection = targetSelector ? document.querySelector(targetSelector) : null;
    if (!targetSection) return;

    event.preventDefault();
    const totalOffset = getTotalOffset();
    window.scrollTo({
      top: targetSection.getBoundingClientRect().top + window.pageYOffset - totalOffset,
      behavior: 'smooth'
    });

    const tabIndex = inlineAnchor.getAttribute('data-index');
    if (tabIndex !== null && tabIndex !== undefined && tabIndex !== '') {
      const tabToOpen = targetSection.querySelector(`.m-tab-header[data-index="${tabIndex}"]`);
      if (tabToOpen) {
        window.requestAnimationFrame(() => tabToOpen.click());
      }
    }
    return;
  }

  const ratingBlock = event.target.closest('[data-v2-rating-scroll]');
  if (!ratingBlock) return;

  const className = (ratingBlock.getAttribute('data-target-class') || '')
    .replace(/^\./, '')
    .trim();
  if (!className) return;

  const targetSection = document.querySelector(`.${className}`);
  if (!targetSection) return;

  event.preventDefault();
  const totalOffset = getTotalOffset();
  window.scrollTo({
    top: targetSection.getBoundingClientRect().top + window.pageYOffset - totalOffset,
    behavior: 'smooth'
  });
});

function trimTrailingDescriptionNodes(container) {
  let lastNode = container.lastChild;

  while (lastNode) {
    if (lastNode.nodeType === Node.TEXT_NODE && !lastNode.textContent.trim()) {
      const previous = lastNode.previousSibling;
      lastNode.remove();
      lastNode = previous;
      continue;
    }

    if (lastNode.nodeType === Node.ELEMENT_NODE && lastNode.tagName === 'BR') {
      const previous = lastNode.previousSibling;
      lastNode.remove();
      lastNode = previous;
      continue;
    }

    if (lastNode.nodeType === Node.ELEMENT_NODE && lastNode.tagName === 'P') {
      trimTrailingDescriptionNodes(lastNode);
      const paragraphText = lastNode.textContent.replace(/\u00a0/g, '').trim();

      if (!paragraphText) {
        const previous = lastNode.previousSibling;
        lastNode.remove();
        lastNode = previous;
        continue;
      }
    }

    break;
  }
}

function normalizeMobileShortDescription() {
  const descriptionNodes = document.querySelectorAll('.v2-short-desc__content');
  descriptionNodes.forEach((node) => trimTrailingDescriptionNodes(node));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', normalizeMobileShortDescription);
} else {
  normalizeMobileShortDescription();
}

function extractTextContent(value) {
  return (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
}

function getVisibleTabHeaders(section) {
  return Array.from(section.querySelectorAll('.m-tab-header')).filter(
    (header) => !header.classList.contains('hide-on-mobile') && !header.classList.contains('hide-on-desk')
  );
}

function getTabContents(section) {
  return Array.from(section.querySelectorAll('.m-tab-content')).filter(
    (content) => !content.classList.contains('hide-on-mobile') && !content.classList.contains('hide-on-desk')
  );
}

function findTabIndexByLabel(headers, pattern) {
  return headers.findIndex((header) => pattern.test(extractTextContent(header.textContent)));
}

function extractSpecRow(liElement) {
  const clone = liElement.cloneNode(true);
  const strong = clone.querySelector('strong, b');

  let label = '';
  let value = '';

  if (strong) {
    label = extractTextContent(strong.textContent);
    strong.remove();
    value = extractTextContent(clone.textContent);
  } else {
    const text = extractTextContent(clone.textContent);
    const parts = text.split(':');
    if (parts.length > 1) {
      label = extractTextContent(parts.shift());
      value = extractTextContent(parts.join(':'));
    } else {
      label = text;
    }
  }

  label = label.replace(/[:\-\u2013\u2014]\s*$/, '').trim();
  value = value.replace(/^[\s:–—-]+/, '').trim();

  if (!label) return null;
  return { label, value };
}

function enhanceSpecsTab(tabContent) {
  if (!tabContent || tabContent.dataset.v2SpecsEnhanced === 'true') return;

  const rte = tabContent.querySelector('.rte');
  if (!rte) return;

  tabContent.classList.add('v2-tab-specs');

  if (rte.querySelector('.v2-specs-table')) {
    tabContent.dataset.v2SpecsEnhanced = 'true';
    return;
  }

  const sourceList = rte.querySelector('ul, ol');
  if (!sourceList) {
    tabContent.dataset.v2SpecsEnhanced = 'true';
    return;
  }

  const liElements = Array.from(sourceList.querySelectorAll(':scope > li'));
  if (!liElements.length) {
    tabContent.dataset.v2SpecsEnhanced = 'true';
    return;
  }

  const rows = liElements.map(extractSpecRow).filter(Boolean);
  if (!rows.length) {
    tabContent.dataset.v2SpecsEnhanced = 'true';
    return;
  }

  const wrap = document.createElement('div');
  wrap.className = 'v2-specs-wrap';

  const table = document.createElement('table');
  table.className = 'v2-specs-table';

  const tbody = document.createElement('tbody');
  rows.forEach((row) => {
    const tr = document.createElement('tr');

    const tdLabel = document.createElement('td');
    tdLabel.textContent = row.label;

    const tdValue = document.createElement('td');
    tdValue.textContent = row.value;

    tr.appendChild(tdLabel);
    tr.appendChild(tdValue);
    tbody.appendChild(tr);
  });

  table.appendChild(tbody);
  wrap.appendChild(table);

  sourceList.replaceWith(wrap);
  tabContent.dataset.v2SpecsEnhanced = 'true';
}

function normalizeFaqQuestion(text) {
  return extractTextContent(text).replace(/^\d+\s*[\).\-:]\s*/, '').trim();
}

function isFaqQuestionNode(node) {
  if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
  if (!['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(node.tagName)) return false;

  const strong = node.querySelector('strong, b');
  const sourceText = strong ? strong.textContent : node.textContent;
  const question = normalizeFaqQuestion(sourceText);
  if (!question) return false;

  return (
    question.includes('?') ||
    /^(are|can|how|what|when|where|why|which|who|do|does|is|will)\b/i.test(question)
  );
}

function buildFaqItems(rte) {
  const nodes = Array.from(rte.children).filter(
    (node) => node.tagName !== 'SCRIPT' && extractTextContent(node.textContent)
  );

  const items = [];
  let currentItem = null;

  nodes.forEach((node) => {
    if (isFaqQuestionNode(node)) {
      if (currentItem && currentItem.question) {
        items.push(currentItem);
      }

      const strong = node.querySelector('strong, b');
      const sourceText = strong ? strong.textContent : node.textContent;
      currentItem = {
        question: normalizeFaqQuestion(sourceText),
        answerHtml: '',
      };
      return;
    }

    if (!currentItem) return;
    currentItem.answerHtml += node.outerHTML;
  });

  if (currentItem && currentItem.question) {
    items.push(currentItem);
  }

  return items.filter((item) => item.question);
}

function enhanceFaqTab(tabContent) {
  if (!tabContent || tabContent.dataset.v2FaqEnhanced === 'true') return;

  const rte = tabContent.querySelector('.rte');
  if (!rte) return;

  tabContent.classList.add('v2-tab-faq');

  if (rte.querySelector('.v2-faq-list')) {
    tabContent.dataset.v2FaqEnhanced = 'true';
    return;
  }

  const faqItems = buildFaqItems(rte);
  if (!faqItems.length) {
    tabContent.dataset.v2FaqEnhanced = 'true';
    return;
  }

  const list = document.createElement('div');
  list.className = 'v2-faq-list';

  faqItems.forEach((item, index) => {
    const faqItem = document.createElement('div');
    faqItem.className = 'v2-faq-item';

    const questionButton = document.createElement('button');
    questionButton.type = 'button';
    questionButton.className = 'v2-faq-q';
    questionButton.setAttribute('aria-expanded', 'false');
    questionButton.setAttribute('data-faq-toggle', '');

    const questionText = document.createElement('span');
    questionText.className = 'v2-faq-q__text';
    questionText.textContent = item.question;

    const icon = document.createElement('span');
    icon.className = 'v2-faq-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '+';

    questionButton.appendChild(questionText);
    questionButton.appendChild(icon);

    const answer = document.createElement('div');
    answer.className = 'v2-faq-a';
    answer.id = `v2-faq-answer-${index}`;
    answer.hidden = true;
    answer.innerHTML = item.answerHtml || '<p></p>';

    questionButton.setAttribute('aria-controls', answer.id);
    faqItem.appendChild(questionButton);
    faqItem.appendChild(answer);
    list.appendChild(faqItem);
  });

  rte.innerHTML = '';
  rte.appendChild(list);
  tabContent.dataset.v2FaqEnhanced = 'true';
}

function bindFaqAccordionHandlers() {
  if (document.body.dataset.v2FaqHandlersBound === 'true') return;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.v2-faq-q[data-faq-toggle]');
    if (!toggle) return;

    const faqItem = toggle.closest('.v2-faq-item');
    const faqList = faqItem ? faqItem.parentElement : null;
    const answer = faqItem ? faqItem.querySelector('.v2-faq-a') : null;
    if (!faqItem || !faqList || !answer) return;

    const willOpen = answer.hidden;

    Array.from(faqList.querySelectorAll('.v2-faq-item')).forEach((item) => {
      const itemAnswer = item.querySelector('.v2-faq-a');
      const itemToggle = item.querySelector('.v2-faq-q');
      if (!itemAnswer || !itemToggle) return;

      item.classList.remove('is-open');
      itemAnswer.hidden = true;
      itemToggle.setAttribute('aria-expanded', 'false');
    });

    if (willOpen) {
      faqItem.classList.add('is-open');
      answer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  document.body.dataset.v2FaqHandlersBound = 'true';
}

function enhanceMobileProductDetailsTabs() {
  if (!document.body.classList.contains('v2-design')) return;
  if (document.body.classList.contains('product-redesign-v2')) return;
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  const sections = document.querySelectorAll('.v2-design .m-product-details-tabs');
  if (!sections.length) return;

  sections.forEach((section) => {
    const headers = getVisibleTabHeaders(section);
    const contents = getTabContents(section);
    if (!headers.length || !contents.length) return;

    const specsIndex = findTabIndexByLabel(headers, /\bspec/i);
    const faqIndex = findTabIndexByLabel(headers, /\bfaq/i);

    if (specsIndex > -1 && contents[specsIndex]) {
      enhanceSpecsTab(contents[specsIndex]);
    }

    if (faqIndex > -1 && contents[faqIndex]) {
      enhanceFaqTab(contents[faqIndex]);
    }
  });

  bindFaqAccordionHandlers();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceMobileProductDetailsTabs);
} else {
  enhanceMobileProductDetailsTabs();
}

document.addEventListener('shopify:section:load', enhanceMobileProductDetailsTabs);
document.addEventListener('shopify:section:select', enhanceMobileProductDetailsTabs);
